import { createAction } from "@reduxjs/toolkit";
import { CookiePreferences } from "./models";

export namespace CookiePolicyActions {
  export enum ActionTypes {
    setCookiePreferences = "Cookie Policy: Set Preferences",
    acceptCookies = "Cookie Policy: Accept Cookies",
    declineCookies = "Cookie Policy: Decline Cookies",
  }

  export const acceptCookies = createAction(ActionTypes.acceptCookies);
  export const declineCookies = createAction(ActionTypes.declineCookies);

  export const setCookiePreferences = createAction<
    Partial<CookiePreferences>,
    ActionTypes.setCookiePreferences
  >(ActionTypes.setCookiePreferences);

  export type AcceptCookies = ReturnType<typeof acceptCookies>;
  export type DeclineCookies = ReturnType<typeof declineCookies>;
  export type SetCookiePreferences = ReturnType<typeof setCookiePreferences>;

  export type Actions = AcceptCookies | DeclineCookies | SetCookiePreferences;
}
